import BaseResource from '@/lib/data/resource/BaseResource'
import { AES }      from '@/lib/crypto/crypto'

export default class ResetPasswordResource extends BaseResource {
  constructor (payload = {}) {
    super(payload)

    this.password = AES.encrypt(payload.Password) ?? null
    this.password_confirmation = AES.encrypt(payload.ConfirmPassword) ?? ''
    this.token = payload.Token ?? ''
    this.email = payload.Email ?? ''
  }

  /* PROPERTIES */

  /* METHODS */
}
